import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { ModalMessageComponent } from 'src/app/modals/modal-message/modal-message.component';
import { Coupon } from 'src/app/model/giveaway';
import { ValidatorUtils } from 'src/app/utils/validator.utils';
import { CouponService } from 'src/app/service/coupon.service';
import { Vip } from 'src/app/model/vip';

@Component({
  	selector: 'modal-vip-coupons',
  	templateUrl: './modal-vip-coupons.component.html',
  	styleUrls: ['./modal-vip-coupons.component.css']
})

export class ModalVipCouponsComponent {

	constructor(
        public modalRef: MDBModalRef, 
        private modalService: MDBModalService,
        private couponService: CouponService,
    ) { }

	action: Subject<any> = new Subject();
    modalRef2: MDBModalRef;
    
    title: string = "";
    is_loaded: boolean = false;

    displayedColumns: string[] = ['code'];
    data_source = new MatTableDataSource<Coupon>();

    vip: Vip;

    validator = new ValidatorUtils();
    email: string = "";
    already_send: boolean = false;
    coupons: string = ""

	ngOnInit() {
        this.data_source.data = this.vip.coupons
        this.already_send = this.vip.coupons[0].alreadySentToClientEmail

        let teste = []
        this.vip.coupons.forEach((coupon, index) => {
            //this.coupons = `${this.coupons},${coupon.exchangeCode}`
            teste.push(coupon.exchangeCode)

            if(index == this.vip.coupons.length-1){
                this.coupons = JSON.stringify(teste).replace(/(\[)|(\])|"/g, "");
            }
        })
    }

    send(){
        if(this.validator.isEmptyOrNull(this.email)){
            this.openMessage('Por favor,', 'insira o email', false)
            return false
        }
        else{
            this.openMessage("Por favor, aguarde", "", true)
            
            this.couponService.exchangeCoupons(this.email, this.vip._id).subscribe( data => {
                    this.modalRef2.hide()
                    this.already_send = true;
                    this.openMessage("Enviado!", "Pacote enviado com sucesso.", false)
            }, error => {
                this.modalRef2.hide()
                this.error(error, 'enviar')
            })
        }
    }

	error(error, string){
        var msg = ""
        if(error.error != null && error.error.error != null && error.error.error.length < 50)
            msg = error.error.error;
        else
            msg = "Por favor verifique as informações inseridas"
        this.openMessage(`Erro, não foi possível ${string} o cupom.`, msg, false)
    }

	openMessage(title, text, bgclick: boolean){
        this.modalRef2 = this.modalService.show(ModalMessageComponent, {
            backdrop: true,
            keyboard: true,
            focus: true,
            show: true,
            ignoreBackdropClick: bgclick,
            class: 'modal-dialog-centered modal-dialog',
            containerClass: '',
            animated: false,
            data: {
                title: title,
                text: text
            }
        })
    }

}